import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import type { ThemeProps, ThemeTokens, CustomThemeButtonProps } from '@atlaskit/button';
import { CustomThemeButton } from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import { token } from '@atlaskit/tokens';

import { QuickSummaryIcon } from '../assets/QuickSummaryIcon';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonTextWrapper = styled.span({
	font: token('font.body'),
	fontWeight: token('font.weight.medium'),
	color: token('color.text'),
});

type SmartsThemedButtonProps = CustomThemeButtonProps & {
	tooltipContent: string;
	buttonText: string;
};

export const SmartsThemedButton: FC<SmartsThemedButtonProps> = ({
	tooltipContent,
	buttonText,
	...props
}) => {
	const customTheme = (
		currentTheme: (props: ThemeProps) => ThemeTokens,
		theme: ThemeProps,
	): ThemeTokens => {
		const existingTheme = currentTheme(theme);

		return {
			...existingTheme,
			buttonStyles: {
				...existingTheme.buttonStyles,
				padding: `${token('space.050')} ${token('space.100')}`,
				alignItems: 'center',
				gap: token('space.025'),
				border: `1.5px solid ${token('color.border')}`,
				borderRadius: '4px',
				'&:hover': {
					backgroundColor: `${token('color.background.accent.gray.subtlest')}`,
				},
			},
		};
	};

	return (
		<>
			<Tooltip hideTooltipOnMouseDown position="bottom" content={tooltipContent}>
				<CustomThemeButton
					theme={customTheme}
					spacing="none"
					testId="footer-comments-summary-button"
					appearance="subtle"
					iconBefore={<QuickSummaryIcon label="" />}
					aria-label={buttonText}
					{...props}
				>
					<ButtonTextWrapper>{buttonText}</ButtonTextWrapper>
				</CustomThemeButton>
			</Tooltip>
		</>
	);
};
